import React, { useState, useEffect } from 'react';

const worksMenuItems = {
  en: [
    { label: 'EV Chargers (GrenVille)', path: '/#work/grenville' },
    { label: 'BYD Taxi Charging Stations', path: '/#work/byd' },
    { label: 'EV Chargers (Fortuna Court)', path: '/#work/fortuna' },
    { label: 'EV Chargers (Leung King Estate)', path: '/#work/leungking' },
    { label: 'EV Chargers (83 King Lam Street)', path: '/#work/kings' },
    { label: 'Smart Estate Management (SEM)', path: '/#work/sem' },
  ],
  zh: [
    { label: '電動車充電器（嘉慧園）', path: '/#work/grenville' },
    { label: '比亞迪出租車充電站', path: '/#work/byd' },
    { label: '電動車充電器（富澤苑）', path: '/#work/fortuna' },
    { label: '電動車充電器（良景邨）', path: '/#work/leungking' },
    { label: '電動車充電器（83京蘭街）', path: '/#work/kings' },
    { label: '智慧屋苑管理系統（SEM）', path: '/#work/sem' },
  ],
};

const Header = ({ language, setLanguage }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header-section ${scrolled ? 'animated fadeInDown' : ''}`}>
      <div className="container">
        <div className="header-wrapper">
          <div className="main__logo">
            <a className="logo" href="/">
              <img src="/assets/home/evgo_logo.png" alt="EvGo Logo" />
            </a>
          </div>
          <ul className="main-menu">
            <li><a href="/">{language === 'zh' ? '主頁' : 'Home'}</a></li>
            <li><a href="/#about">{language === 'zh' ? '關於我們' : 'About'}</a></li>
            <li>
              <a href="/#services">{language === 'zh' ? '服務' : 'Services'}</a>
              <ul className="sub-menu">
                <li><a href="/#ev-chargers">{language === 'zh' ? '電動車充電器及數字支付系統' : 'EV Chargers & Digital Payment System'}</a></li>
                <li><a href="/#ev-chargers">{language === 'zh' ? '雲端及中央管理' : 'Cloud & Central Management'}</a></li>
                <li><a href="/#property-management">{language === 'zh' ? '物業管理費系統' : 'Property Management Fee System'}</a></li>
                <li><a href="/#enotice-system">{language === 'zh' ? '電子通知系統' : 'ENotice System'}</a></li>
                <li><a href="/#ai-marketing">{language === 'zh' ? 'AI智能營銷及數字屏幕' : 'AI Smart Marketing & Digital Screen'}</a></li>
                <li><a href="/#others">{language === 'zh' ? '其他' : 'Others'}</a></li>
              </ul>
            </li>
            <li>
              <a href="/#work">{language === 'zh' ? '工程案例' : 'Work'}</a>
              <ul className="sub-menu">
                {(worksMenuItems[language] || worksMenuItems.en).map((item) => (
                  <li key={item.path}><a href={item.path}>{item.label}</a></li>
                ))}
              </ul>
            </li>
            <li><a href="/#contact">{language === 'zh' ? '聯絡我們' : 'Contact'}</a></li>
          </ul>
          <div className="menu__components d-flex align-items-center">
            <button 
              className="language-selector"
              onClick={() => setLanguage(language === 'en' ? 'zh' : 'en')}
            >
              {language === 'en' ? '中文' : 'EN'}
            </button>
            <a className="d-flex fw-500 cmn--btn align-items-center gap-2" href="/#contact">
              <span className="get__text">Let's Talk</span>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" className="fz-20">
                  <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"></path>
                </svg>
              </span>
            </a>
            <div className={`header-bar ${mobileMenuOpen ? 'active' : ''}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div className={`subside__barmenu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="remove__click d-flex justify-content-center align-items-center" onClick={() => setMobileMenuOpen(false)}>
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor">
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"></path>
            </svg>
          </i>
        </div>
        <div className="sub__contact__wrapper d-grid">
          <a className="side-logo" href="/">
            <img style={{ width:''}} src="/assets/home/evgo_logo.png" alt="EvGo Logo" />
          </a>

          <ul className="mobile-nav">
            <li><a href="/" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '主頁' : 'Home'}</a></li>
            <li><a href="/#about" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '關於我們' : 'About'}</a></li>
            <li>
              <a href="/#services" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '服務' : 'Services'}</a>
              <ul className="mobile-nav__sub">
                <li><a href="/#ev-chargers" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '電動車充電器及數字支付系統' : 'EV Chargers & Digital Payment System'}</a></li>
                <li><a href="/#ev-chargers" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '雲端及中央管理' : 'Cloud & Central Management'}</a></li>
                <li><a href="/#property-management" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '物業管理費系統' : 'Property Management Fee System'}</a></li>
                <li><a href="/#enotice-system" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '電子通知系統' : 'ENotice System'}</a></li>
                <li><a href="/#ai-marketing" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? 'AI智能營銷及數字屏幕' : 'AI Smart Marketing & Digital Screen'}</a></li>
                <li><a href="/#others" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '其他' : 'Others'}</a></li>
              </ul>
            </li>
            <li>
              <a href="/#work" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '工程案例' : 'Work'}</a>
              <ul className="mobile-nav__sub">
                {(worksMenuItems[language] || worksMenuItems.en).map((item) => (
                  <li key={item.path}><a href={item.path} onClick={() => setMobileMenuOpen(false)}>{item.label}</a></li>
                ))}
              </ul>
            </li>
            <li><a href="/#contact" onClick={() => setMobileMenuOpen(false)}>{language === 'zh' ? '聯絡我們' : 'Contact'}</a></li>
          </ul>

          <div className="sub__contact-left d-grid">
            <div className="sub__contac-item">
              <div className="content">
                <span className="address d-block">address</span>
                <span className="textp">RM B, 7/F, One Capital Place, 18 Luard Road, Wan Chai, Hong Kong</span>
              </div>
            </div>
            <div className="sub__contac-item">
              <div className="content">
                <span className="address d-block">email</span>
                <a className="textp" href="mailto:hkevgo@gmail.com">hkevgo@gmail.com</a>
              </div>
            </div>
          </div>
          
          <a className="d-flex justify-content-center fw-500 cmn--btn align-items-center gap-2" href="/#contact">
            <span>
              <i>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor">
                  <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
              </i>
            </span>
            <span className="get__text">Let's Talk</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
